// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gfxNEsmU47oCEEa1g9IB{border-bottom:1px solid var(--border-neutral-default);flex-direction:column;gap:8px;height:114px;padding:30px 20px 24px;display:flex;overflow:hidden}.hwsMNnmq_s03ut2dqgXv{justify-content:space-between;align-items:center;gap:8px;display:flex}.Y1oPVgZ8Q48QrsSf1A40{align-items:center;gap:8px;display:flex}.k9f8TsVV17AqvFMlmCyf{height:20px;margin:0}.tS937g36aCU8fhpUIpRL{align-items:center;gap:10px;padding:0 8px;display:flex;overflow:hidden}.fhLCYo2reUWPVftPnymA{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `gfxNEsmU47oCEEa1g9IB`,
	"bottom": `hwsMNnmq_s03ut2dqgXv`,
	"bottom__box": `Y1oPVgZ8Q48QrsSf1A40`,
	"bottomBox": `Y1oPVgZ8Q48QrsSf1A40`,
	"breadcrumbs": `k9f8TsVV17AqvFMlmCyf`,
	"info": `tS937g36aCU8fhpUIpRL`,
	"info__name": `fhLCYo2reUWPVftPnymA`,
	"infoName": `fhLCYo2reUWPVftPnymA`
};
export default ___CSS_LOADER_EXPORT___;
